import { AvailableHoursResponse } from "modules/BookingCommon/common/interfaces"
import { getNewUtcDate, setUtcHours } from "modules/BookingCommon/common/utils"
import { REG_DATE, REG_TIME_WITH_DURATION } from "modules/BookingCommon/common/constants"
import * as utils from "utils/utils"
import { SESSION_LENGTH } from "utils/env-management"
import { AvailableLocalHours } from "modules/Booking/components/TimeRequestModal/common/interfaces"

export interface SessionLocalTimeSlot {
    id: string
    sessionDateTime: Date
    localStart: string
    localEnd: string
    duration: number
}

export function preprocessAvailableHours(response: AvailableHoursResponse) {
    const slots: AvailableLocalHours = {}

    for (const utcDateStr in response) {
        const matchDate = utcDateStr.match(REG_DATE)
        if (!matchDate) {
            continue
        }
        const startSessionDate = getNewUtcDate(matchDate)

        for (const slot of response[utcDateStr]) {
            const matchSlotTime = slot.time.match(REG_TIME_WITH_DURATION)

            if (!matchSlotTime) {
                continue
            }

            const startSession = setUtcHours(startSessionDate, matchSlotTime[1], matchSlotTime[2])

            const duration = parseInt(matchSlotTime[3]) || SESSION_LENGTH

            const endSession = new Date(startSession.getTime() + duration * 60 * 1000)

            const date = utils.formatLocalDate(startSession)
            if (!Object.prototype.hasOwnProperty.call(slots, date)) {
                slots[date] = []
            }

            slots[date].push({
                id: slot.id,
                sessionDateTime: startSession,
                localStart: utils.formatLocalTime(startSession),
                localEnd: utils.formatLocalTime(endSession),
                duration,
            })
        }
    }

    return slots
}
